export const copyToClipboard = (text: string) => {
  const el = document.createElement("textarea");
  el.value = encodeURI(text);
  document.body.appendChild(el);
  el.select();
  document.execCommand("copy");
  document.body.removeChild(el);
};
